import * as table from '@/constants/components/table'

export const TableColumnsOA: Array<table.TableColumn> = [
  { value: 'detail', text: '詳細', width: '' },
  { value: 'estimate_subject', text: '見積件名', width: '' },
  { value: 'estimate_version_name', text: '見積版名', width: '' },
  { value: 'fileAttach', text: '見積書添付', width: '' },
  { value: 'show', text: '見積発行履歴', width: '' },
  { value: 'commodity_name', text: '商材', width: '' },
  { value: 'final_quote', text: '最終見積', width: '' },
  { value: 'leasing_name', text: '顧客・リース会社', width: '' }
];

export const TableColumnsGeneral: Array<table.TableColumn> = [
  { value: 'detail', text: '詳細', width: '' },
  { value: 'estimate_subject', text: '見積件名', width: '' },
  { value: 'estimate_version_name', text: '見積版名', width: '' },
  { value: 'fileAttach', text: '見積書添付', width: '' },
  { value: 'show', text: '見積発行履歴', width: '' },
  { value: 'commodity_name', text: '商材', width: '' },
  { value: 'final_quote', text: '最終見積', width: '' }
];

export const TableColumnsFJapan: Array<table.TableColumn> = [
  { value: 'detail', text: '詳細', width: '' },
  { value: 'estimate_subject', text: '見積件名', width: '' },
  { value: 'estimate_version_name', text: '見積版名', width: '' },
  { value: 'fileAttach', text: '見積書添付', width: '' },
  { value: 'show', text: '見積発行履歴', width: '' },
  { value: 'commodity_name', text: '商材', width: '' },
  { value: 'final_quote', text: '最終見積', width: '' }
];

export const ButtonItems: any = [
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "detail",
    'text': "詳細",
    'disabled': false
  },
  {
      'alwaysDisplayed': false,
      'class': 'btn-normal',
      'name': "show",
      'text': "表示",
      'disabled': false
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "fileAttach",
    'text': "添付",
    'disabled': false,
    'changeText': "添付有",
    'fieldId': 'translation'
  },
]

export const DialogHeaderDetailDataTitle = '見積発行履歴';
export const DialogHeaderDetailColmuns = [
  { text: '発行者', value: 'issuer', width: '70' },
  { text: '発行日時', value: 'issue_datetime', width: '80' }
];

export const EstimateBasicFileDialogTitle = '見積書添付';
export const EstimateBasicFileDialogColumnItems = [
  { text: '見積ファイル名', value: 'name' },
  { text: 'サイズ（byte）', value: 'size' }
];

export const TableBody: Array<any> = [];

export const TableParametersOA: table.TableParameters = {
  columns: TableColumnsOA,
  body: TableBody,
  buttonItems: ButtonItems,
}

export const TableParametersGeneral: table.TableParameters = {
  columns: TableColumnsGeneral,
  body: TableBody,
  buttonItems: ButtonItems,
}

export const TableParametersFJapan: table.TableParameters = {
  columns: TableColumnsFJapan,
  body: TableBody,
  buttonItems: ButtonItems,
}

// 案件詳細＞事前与信タブ内一覧テーブルカラム
export const ProjectCreditTableColumns: Array<table.TableColumn> = [
  { value: 'display_order', text: 'No', width: '' },
  { value: 'deleteButton', text: '削除', width: '' },
  { value: 'selectButtonIndex', text: '検索', width: '' },
  { value: 'leasing_company', text: 'リース会社名', width: '' },
  { value: 'check_status', text: '審査結果', width: '' },
  { value: 'approval_monthly_lease_fee', text: '承認金額(月額リース金額)', width: '' },
  { value: 'approval_contract_month', text: '承認期間', width: '' },
  { value: 'product_classification', text: '商品区分', width: '' },
  { value: 'approval_number', text: '承認番号', width: '' },
  { value: 'applyButton', text: '申込情報', width: '' }
];

// 案件詳細＞事前与信タブ内一覧テーブルボタン
// Enabled
export const ProjectCreditButtonItems: any = [
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'deleteButton',
    text: '削除',
    disabled: false
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'selectButtonIndex',
    text: '検索',
    disabled: false
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'applyButton',
    text: '申込情報',
    disabled: false
  }
];
// 案件詳細＞事前与信タブ内一覧テーブルボタン
// Disabled（申込情報ボタンは常にEnabled）
export const ProjectCreditButtonDisabledItems: any = [
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'deleteButton',
    text: '削除',
    disabled: true
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'selectButtonIndex',
    text: '検索',
    disabled: true
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'applyButton',
    text: '申込情報',
    disabled: false
  }
];

// 案件詳細＞事前与信タブ内一覧テーブル定義
export const ProjectCreditTableBody: Array<any> = [];
export const ProjectCreditTableParameters: table.TableParameters = {
  columns: ProjectCreditTableColumns,
  body: ProjectCreditTableBody,
  buttonItems: ProjectCreditButtonDisabledItems
};

// 案件詳細＞事前与信タブ内一覧入力項目
export const ProjectCreditInputItems = [
  {
    name: 'check_status',
    optionId: 'check_status_id',
    type: 'select',
    options: [],
    inputCheckFlag: true,
    hideDetails: 'auto',
    rules: []
  },
  {
    name: 'approval_monthly_lease_fee',
    type: 'number',
    rules: [],
    hideDetails: 'auto',
    inputCheckFlag: true
  },
  {
    name: 'approval_contract_month',
    type: 'number',
    rules: [],
    hideDetails: 'auto',
    inputCheckFlag: true
  },
  {
    name: 'approval_number',
    type: 'text',
    inputCheckFlag: true,
    hideDetails: 'auto',
    rules: []
  }
];
